import { getFavoriteSections } from '@/fsd/entities/favorite/api/getFavoriteSections';
import { usePortalPlacement } from '@/fsd/shared/ui/AutocompleteSelect/hooks/usePortalPlacement';
import { useQuery } from '@tanstack/react-query';
import cx from 'classnames';
import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { NavLink } from 'react-router-dom';
import { rawMenuData } from '../../model/helpers/rawMenuData';
import { useFilteredMenuData } from '../../model/hooks/useFilteredMenuData';
import { useLocationPathCheck } from '../../model/hooks/useLocationPathCheck';
import style from '../header.module.scss';
import HeaderMainMenuFavoriteButton from './HeaderMainMenuFavoriteButton/HeaderMainMenuFavoriteButton';

const HeaderMainMenuItem = ({
  menuKey,
  menuData,
  isHovered,
  onMouseEnter,
  onMouseLeave,
}) => {
  const { isActive, items, to } = menuData;
  const menuItemRef = useRef(null);
  const coords = usePortalPlacement(menuItemRef, isHovered);

  return (
    <div
      ref={menuItemRef}
      className={cx(style['header-nav__item'], style['header-nav__item-menu'])}
      key={menuKey}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {to ? (
        <NavLink
          to={to}
          className={({ isActive }) => (isActive ? style.active : '')}
        >
          {menuKey}
        </NavLink>
      ) : (
        <span className={isActive ? style['activeItem'] : ''}>{menuKey}</span>
      )}
      {items &&
        typeof items === 'object' &&
        isHovered &&
        coords &&
        createPortal(
          <div
            className={cx(style['sub-menu'], {
              [style.visible]: isHovered,
            })}
            style={{
              position: 'absolute',
              top: `${coords.top}px`,
              left: `${coords.left}px`,
              zIndex: 1100,
            }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            {Object.keys(items).map((subMenuKey) => (
              <div className={style['sub-menu__item']} key={subMenuKey}>
                <div className={style['sub-menu__item_title']}>
                  {subMenuKey}
                </div>
                {items[subMenuKey].map((item, index) => (
                  <NavLink
                    to={item.to}
                    className={({ isActive }) => (isActive ? style.active : '')}
                    key={index}
                  >
                    <span className={style['sub-menu__item_link']}>
                      {/*{item.icon && (*/}
                      {/*  <HeaderMainMenuFavoriteButton*/}
                      {/*    icon={item.icon}*/}
                      {/*    title={item.section}*/}
                      {/*    url={item.to}*/}
                      {/*  />*/}
                      {/*)}*/}
                      {item.label}
                    </span>
                  </NavLink>
                ))}
              </div>
            ))}
          </div>,
          document.body
        )}
    </div>
  );
};

const HeaderMainMenu = () => {
  const hoverTimeout = useRef<ReturnType<typeof setTimeout>>();

  const [reportIsActive, setReportIsActive] = useState(false);
  const [SchedulerIsActive, setSchedulerActive] = useState(false);
  const [hoveredMenu, setHoveredMenu] = useState<string | null>(null);

  const { data: favoriteSections } = useQuery({
    queryKey: ['favorite-sections'],
    queryFn: getFavoriteSections,
  });

  // const menuData = useFilteredMenuData({
  //   menuData: rawMenuData({ reportIsActive, SchedulerIsActive }),
  // });

  const menuData = rawMenuData({
    reportIsActive,
    SchedulerIsActive,
  });

  // const menuData = useFilteredMenuData({
  //   menuData: rawData,
  // });

  // console.log('RAW MENU:', rawData);
  console.log('FILTERED MENU:', menuData);

  useLocationPathCheck({ setReportIsActive, setSchedulerActive });

  return (
    <>
      {Object.keys(menuData).map((menuKey) => (
        <HeaderMainMenuItem
          key={menuKey}
          menuKey={menuKey}
          menuData={menuData[menuKey]}
          isHovered={hoveredMenu === menuKey}
          onMouseEnter={() => {
            clearTimeout(hoverTimeout.current);
            setHoveredMenu(menuKey);
          }}
          onMouseLeave={() => {
            hoverTimeout.current = setTimeout(() => {
              setHoveredMenu(null);
            }, 300);
          }}
        />
      ))}
    </>
  );
};

export default HeaderMainMenu;
